var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCitigroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 800,
    width: 1200,
    viewBox: "-44.4 -47.73875 384.8 286.4325",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#003b70",
    d: "M90.13 154.048l-.53.513c-8.533 8.694-18.411 13.303-28.59 13.303-21.244 0-36.666-15.938-36.666-37.93 0-21.95 15.422-37.91 36.667-37.91 10.178 0 20.056 4.626 28.59 13.344l.53.528 13.662-16.521-.365-.449C92.065 75.5 78.431 68.962 61.67 68.962c-16.819 0-32.194 5.66-43.274 15.869C6.356 95.885 0 111.475 0 129.935c0 18.45 6.356 34.079 18.396 45.136 11.08 10.255 26.455 15.884 43.274 15.884 16.761 0 30.395-6.532 41.758-19.965l.365-.417zm27.47 34.659h24.137V70.877H117.6zm118.685-25.621c-6.44 3.92-12.433 5.892-17.815 5.892-7.798 0-11.322-4.116-11.322-13.284v-62.52h24.583v-22.19h-24.583V34.321L183.49 46.98v24.003h-20.41v22.19h20.41v66.508c0 18.12 10.734 30.5 26.757 30.822 10.88.213 17.438-3.028 21.421-5.398l.234-.173 5.81-22.72-1.427.873zm19.991 25.621h24.154V70.877h-24.154z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#d9261c",
    fillRule: "evenodd",
    d: "M294.887 49.97C272.792 18.671 236.098 0 198.765 0c-37.318 0-74.02 18.672-96.078 49.97l-1.132 1.61h27.821l.308-.334c18.936-19.544 43.655-29.88 69.08-29.88 25.43 0 50.144 10.336 69.116 29.88l.308.334H296z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCitigroup);
export default __webpack_public_path__ + "static/media/Citigroup.d4b5903d431219219039bc5cf34ec76f.svg";
export { ForwardRef as ReactComponent };